import { render, staticRenderFns } from "./UploadedFileDetails.vue?vue&type=template&id=00888592&scoped=true&"
import script from "./UploadedFileDetails.vue?vue&type=script&lang=js&"
export * from "./UploadedFileDetails.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFileDetails.vue?vue&type=style&index=0&id=00888592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00888592",
  null
  
)

export default component.exports